 <template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col style="padding:0" align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')"
                v-b-toggle.menu-sidebar
              >
            </div>
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="w-pagetitle" style="margin-left:20px;margin-right:10px; text-align:right;">{{cellar.name}} > {{ translate("dashboard") }}</p>
            <div id="container_ofBottles">
              <h1 class="d-big text-center"><span style="color: rgb(109,122,82)">{{number_ofBottles}}</span></h1>
              <p class="d-label text-center">{{ translate("number of bottles in cellar") }}</p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div id="container_perColor">
              <zingchart 
                ref="cellar_perColor"
                :data="cellar_perColor"
              ></zingchart>
              <div id="hide">
                <p style="color:white">Nothing</p>
                <p style="color:white">Nothing</p>
              </div>
            </div>
          </b-col>   
        </b-row>

        <hr class="correct">
        <b-row> 
          <b-col lg="6">
            <div id="container_perCountry" class="m-box">
              <zingchart v-if="level==0"
                ref="cellar_perCountry"
                :data="cellar_perCountry" 
                @node_click="handle_countryClick"
              ></zingchart>
              <zingchart v-if="level==1"
                ref="cellar_perRegion"
                :data="cellar_perRegion" 
                @node_click="handle_regionClick"
              ></zingchart>
              <zingchart v-if="level==2"
                ref="cellar_perAppellation" 
                :data="cellar_perAppellation" 
                @node_click="handle_appellationClick" 
              ></zingchart>
              <b-button v-if="level > 0" style="position:absolute; top:40px; right:-15px" v-on:click="onLevelBack()" class="c-button-pink">back</b-button>
            </div>
          </b-col>
        </b-row>
        <hr class="correct">
        <b-row>
          <b-col lg="6" >
            <div id="container_perVintage" class="m-box">
              <zingchart 
                ref="cellar_perVintage" 
                :data="cellar_perVintage"
              ></zingchart>
            </div>
          </b-col>
        </b-row>
        <hr class="correct">
        <b-row>
          <b-col lg="6">
            <div v-if="transactionsLoading">
              loading transactions...
            </div>
            <div id="container_recentTransactions" class="m-box">
              <p class="dashboard-title"> {{ translate("recent transactions") }}</p>
              <b-table 
                ref="transactionsTable"
                class="w-table"
                style="overflow:scroll !important"
                sticky-header=true
                hover
                :items="transactions" 
                :fields="transaction_fields" 
              >
              </b-table>
            </div>
          </b-col>
        </b-row>        
        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <!-- <template #default="{ hide }">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/close.png')"
                @click="hide"
              >
            </div>
            <hr>
            <Menu/>
          </template> -->
          <template #default="{ hide }">
            <div style="display: flex; align-items: center;">
              <div style="display: flex;align-items: center; width:25 px">
                <b-dropdown 
                  left 
                  split 
                  text="language" 
                  class="language-dropdown" 
                  toggle-class="toggle-language" 
                  split-class="split-language" 
                  style="display: flex;font-size: 12px;margin:15px 0 0 10px"
                >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>

                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('pt')">
                      <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                      Português (Portuguese)
                    </b-dropdown-item>
                </b-dropdown>
              </div>
              <div style="display: flex; align-items: center;">
                <p style="margin:20px 0 0 40px;"><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
              </div>
              <div style="display: flex; align-items: center; width:25 px">
                <img class="menu-overlay"
                  :src="require('@/assets/img/close.png')" 
                  style="width: 25px; height: 25px; cursor: pointer;" 
                  @click="hide"
                >
              </div>
            </div>
            <hr>
            <Menu/> 
          </template>
        
        </b-sidebar>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>

    <b-modal id="Warning" size="md" @ok="switch2ProfileLanguage" @cancel="changeProfileanguage">
      <template #modal-header>
        <div>
          <font-awesome-icon 
          id="warning"
          class="w-cursor-click" 
          style="font-size:24px;display:inline-block" 
          icon="exclamation-triangle"
          color="rgb(195,147,130)" 
        />
        <p style="display:inline-block; margin-bottom:0; font-size:24px; font-weight:bold; color:rgb(195,147,130)">&nbsp warning</p>       
        </div>
      </template>

      <p class="w-subtitle"> {{ translate_language("Your chosen language is",this.currentLanguage) }} <b>{{ getLanguageName(currentLanguage) }}</b>, {{translate_language("while your profile language is",user.language) }} <b>{{ getLanguageName(currentUser.language) }}.</b></p>
      <p class="w-subtitle"> {{ translate_language("Option 1: Shall I switch over to your profile language and continue in", user.language) }} <span style="color:rgb(109,122,82)"><b>{{ getLanguageName(user.language) }}</b></span>?</p>
      <p class="w-subtitle"> {{ translate("Option 2: Shall I change your profile language to") }} <span style="color:rgb(195,147,130)"><b>{{ getLanguageName(currentLanguage) }}</b></span > {{ translate("and continue in")}} <span style="color:rgb(195,147,130)"> <b>{{ getLanguageName(currentLanguage) }}</b></span>?</p>
      <template #modal-footer="{ ok, cancel }">
        <b-row style="width:100%">  
          <b-col class="text-left" style="padding:0">
            <b-button class="w-button-pink" @click="cancel()">
              {{ getLanguageName(currentLanguage) }}
            </b-button>
          </b-col>
          <b-col class="text-right" style="padding:0">
            <b-button class="w-button-green" @click="ok()">
              {{ getLanguageName(user.language) }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import 'zingchart/es6';
  import zingchartVue from 'zingchart-vue';
  import Queries from '../Queries.js'

  import NoAccess from '@/components/NoAccess.vue';
  import Menu from '@/components/MenuMobile.vue';

  import Users from '../Users.js';
  import Cellars from '../Cellars.js';
  import Niches from '../Niches.js';
  import Entries from '../Entries.js';
  import Transactions from '../Transactions.js';

  import C_Wines from '../C_Wines.js';
  import C_Wine_from_Entry_id from '../C_Wine_from_Entry_id.js'

  import formatDate from '../assets/js/formatDate.js';
  import wait from '../assets/js/wait.js';

  export default {
    name: 'Dashboard',
    components:{
      NoAccess,
      Menu,
      zingchart: zingchartVue
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      },
      
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },    
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },

      currentCellarID() {
        return this.$store.state.cellar_id
      },
      currentCellar() {
        return this.$store.state.cellar
      },
      currentCellarLoaded() {
        return this.$store.state.cellar_loaded
      },

      cellar_perCountry(){
        return {
          id: 'cellar_perCountry',
          type: 'bar',
          height: '90%',
          width: '100%',
          title:{
            text: this.translate(this.title),
            'font-family': 'Segoe UI',
            'font-size': '24'
          },
          scaleX: {
            item: {
              fontAngle: 90,
              wrapText: false,
              maxChars: 15,
            },
            itemsOverlap: true,
            maxItems: 99,
            label: {
              text: this.translate('country')
            },
            labels: this.country_labels,
          },
          series: [{
            "background-color": "#6D7A52", 
            alpha: 0.8, 
            values: this.country_values
          }],
          gui : {
            contextMenu : {
              empty : true
            }
          }          
        }
      },
      cellar_perRegion(){
        return {
          id: 'cellar_perRegion',
          type: 'bar',
          height: '90%',
          width: '100%',          
          title:{
            text: this.title,
            'font-family': 'Segoe UI',
            'font-size': '24'
          },
          scaleX: {
            item: {
              fontAngle: 90,
              wrapText: false,
              maxChars: 15,
            },
            itemsOverlap: true,
            maxItems: 99,
            label: {
              text: this.translate('regions')
            },
            labels: this.region_labels
          },
          series: [{
            "background-color": "#6D7A52", 
            alpha: 0.8, 
            values: this.region_values
          }],
          gui : {
            contextMenu : {
              empty : true
            }
          }          
        }
      },
      cellar_perAppellation(){
        return {
          id: 'cellar_perAppellation',
          type: 'bar',
          height: '90%',
          width: '100%',
          title:{
            text: this.title,
            'font-family': 'Segoe UI',
            'font-size': '24'
          },
          scaleX: {
            item: {
              fontAngle: 90,
              wrapText: false,
              maxChars: 15,
            },
            itemsOverlap: true,
            maxItems: 99,
            label: {
              text: this.translate('appellations')
            },
            labels: this.appellation_labels
          },
          series: [{
            "background-color": "#6D7A52", 
            alpha: 0.8, 
            values: this.appellation_values
          }],
          gui : {
            contextMenu : {
              empty : true
            }
          }          
        }
      },
      cellar_perVintage(){
        return {
          id: 'cellar_perVintage',
          type: 'bar',
          title:{
            text: this.translate("vintages"),
            'font-family': 'Segoe UI',
            'font-size': '24'
          },
          scaleX: {
            item: {
              fontAngle: 90,
            },
            itemsOverlap: true,
            maxItems: 99,
            label: {
              text: this.translate('vintage'),
            },
            labels: this.vintage_labels,
          },
          scaleY: {
            itemsOverlap: true,
          },
          series: [{
            "background-color": "#6D7A52", 
            alpha: 0.8, 
            values: this.vintage_values
          }],
          gui : {
            contextMenu : {
              empty : true
            }
          }          
        }
      },
      long_x_label(){
        return {
          id: 'long_x_label',
          type: 'bar',
          height: '90%',
          width: '100%',
          title:{
            text: "a long x label",
            'font-family': 'Segoe UI',
            'font-size': '24'
          },
          scaleX: {
            item: {
              fontAngle: 90,
              wrapText: false,
              maxChars: 15,
            },
            itemsOverlap: true,
            maxItems: 99,
            label: {
              text: 'letters',
            },
            labels: ["some a","some b","some c","some long x label here","some e","some f","some g","some h","some i","some j"],
          },
          scaleY: {
            itemsOverlap: true,
          },
          series: [{
            "background-color": "#6D7A52", 
            alpha: 0.8, 
            values: [0,1,2,3,4,5,6,7,8,9]
          }],
          gui : {
            contextMenu : {
              empty : true
            }
          }          
        }
      },
      cellar_perColor(){
        return {
          id: 'cellar_perColor',
          type: 'pie3d',
          series: this.color_series,
          height: "300px",
          gui : {
            contextMenu : {
              button: { visible: false }, 
              visible : false
            }
          }          
        }
      },
      formattedCellarValue() {
        return new Intl.NumberFormat('de-DE', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.cellarValue);
      },
      transaction_fields() {
        return [
          {
            key: 'date',
            label: this.translate("date"),
            sortable: true,
            formatter: (value) => formatDate(new Date(value)),
            thClass: 'myClass10',
            tdClass: 'myClass10'
          },
          {
            key: 'number',
            label: '#',
            sortable: false,
            class: 'text-center',
            thClass: 'myClass10',
            tdClass: 'myClass10'
          },
          {
            key: 'wine',
            label: this.translate("wine"),
            sortable: false,
            thClass: 'myClass30',
            tdClass: 'myClass30'
          },
          {
            key: 'vintage',
            label: this.translate("vintage"),
            sortable: false,
            class: 'text-center',
            thClass: 'myClass10',
            tdClass: 'myClass10'
          },
          {
            key: 'description',
            label: this.translate("description"),  // 🛠️ Fixed typo here from "desciption"
            sortable: false,
            thClass: 'myClass30',
            tdClass: 'myClass30'
          },
          {
            key: 'price',
            label: this.translate("price"),
            sortable: false,
            class: 'text-right',
            thClass: 'myClass10',
            tdClass: 'myClass10'
          }
        ];
      }
    },
    data() {
      return {
        debug: false,
        isLoading: true,
        transactionsLoading: false,

        user: {
        },
        user_id: 0,
        
        cellar: {
        },
        cellar_id: 0,

        number_ofBottles: 0,
        
        level: 0,
        title: 'countries',

        currentCountryID: '',
        currentCountry: '',
        country_ids: [],
        country_labels: [],
        country_values: [],

        currentRegionID: '',
        currentRegion: '',
        region_ids: [],
        region_labels: [],
        region_values: [],

        currentAppellationID: '',
        currentAppellation: '',
        appellation_ids: [],
        appellation_labels: [],
        appellation_values: [],

        vintage_labels: [],
        vintage_values: [],

        color_series: [],

        // transaction_fields: [
        //   {key: 'date', label: this.translate("date"), sortable: true,
        //     formatter: (value) => {
        //       return(formatDate(new Date(value)))}, thClass: 'myClass10', tdClass: 'myClass10'},
        //   {key: 'number',label: '#', sortable: false, class: 'text-center', thClass: 'myClass10', tdClass: 'myClass10'},
        //   {key: 'wine',label: this.translate("wine"), sortable: false, thClass: 'myClass30', tdClass: 'myClass30'},
        //   {key: 'vintage',label: this.translate("vintage"), sortable: false, class: 'text-center', thClass: 'myClass10', tdClass: 'myClass10'},
        //   {key: 'description',label: this.translate("desciption"), sortable: false, thClass: 'myClass30', tdClass: 'myClass30'},
        //   {key: 'price',label: this.translate("price"), sortable: false, class:'text-right',thClass: 'myClass10', tdClass: 'myClass10'},
        // ],
        transactions:[],

        isChecking:false,

        pricesChecked:false,
        cellarLoaded:false,
        spreadsheetReady:false,

        cellarDoesNotExist:false,
        cellarInconsitent:false,

        entries:[],
        currencies:[],
        vatStati:[],
        zeroPrice:0,
        currency_OK:false,
        currency_comment:"",
        vatStatus_OK:false,
        vatStatus_comment:"",
        cellarValue:0,
        main_currency:"",
        main_vatStatus:"",

        entries_with_currency:[],
        EWC_title: "",
        entries_with_vatStatus:[],
        EWV_title:"",

        inconsistent_entries:[],
        count_entries_in_niche:0,
      }
    },
    
    async mounted() {
      let local_debug = false 
      if (local_debug || this.debug) console.log("")
      if (local_debug || this.debug) console.log("Dashboard.mounted: START")
      
      let time_0 = new Date().getTime()

      this.user_id = this.currentUserID
      this.user = this.currentUser

      if (this.previousPage == 'Login') {
        if ( this.currentLanguage != this.user.language ) {
          this.$root.$emit("bv::show::modal", "Warning");
        }
      }
      
      if (this.currentCellarLoaded) {
        if (local_debug || this.debug) console.log("Dashboard.mounted: CURRENT CELLAR LOADED")
        this.cellar = this.currentCellar
        this.cellar_id = this.currentCellarID
        if (local_debug || this.debug) console.log("Dashboard.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully retrieved from store.")
      }
      else {
        if (local_debug || this.debug) console.log("Dashboard.mounted: CURRENT CELLAR NOT LOADED - QUERYING THE DATABASE")
        if (typeof this.$route.query.cellar_id == "undefined") {
          if (local_debug || this.debug) console.log("Dashboard.mounted: FATAL ERROR - this.$route.query.cellar_id = ", this.$route.query.cellar_id)
          alert("Dashboard.mounted: FATAL ERROR - this.$route.query.cellar_id = " + this.$route.query.cellar_id)
          return
        }  
        this.cellar_id = this.$route.query.cellar_id
        await Cellars.getone(this.cellar_id)
        .then(response => {
          this.cellar = response
          delete this.cellar._id
          if (local_debug || this.debug) console.log("Dashboard.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully fetched from DB.")
        })
        .catch(error =>{
          if (local_debug || this.debug) console.log("Dashboard.mounted: catch Cellar.getone with error: ", error)
        })

        this.$store.commit('setCellar',this.cellar)
        this.$store.commit('setCellarID',this.cellar_id)
        this.$store.commit('setCellarLoaded',true)

        if (local_debug || this.debug) console.log("Dashboard.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully stored in store.")
      }

      if (typeof this.cellar != "object") {
        if (local_debug || this.debug) console.log("-----> Dashboard.mounted: There is a problem with cellar with id = ", this.cellar_id);
        this.cellarDoesNotExist = true
      } else {
          await this.showFigures();
          await this.showColors();
          this.showCountries();
          this.showVintages();

          this.isLoading = false

          this.transactionsLoading = true
          this.showTransactions()
            .finally(() => {
              this.transactionsLoading = false
            })
      }

      // Preload the niches
      if (local_debug || this.debug) console.log("Dashboard.mounted: This cellar has ", this.cellar.niche_ids.length, " niches:");
      if (this.currentNichesLoaded ) {
        if (local_debug || this.debug) console.log("Dashboard.mounted: CURRENT NICHES LOADED")
        this.niches = this.currentNiches
        if (local_debug || this.debug) console.log("Dashboard.mounted: niches ", this.niches, " succesfully retrieved from store.")
        let time_2 = new Date().getTime()
        console.log("Loading Niches from STORE: ", time_2 - time_1, " ms")
      } else {
        if (local_debug || this.debug) console.log("Dashboard.mounted: CURRENT NICHES NOT LOADED - QUERYING THE DATABASE")

        if (this.cellar.niche_ids && this.cellar.niche_ids.length > 0) {
          const validNicheIds = this.cellar.niche_ids.filter(
            id => id && id.length === 24
          )

          this.niches = await Niches.getmany(validNicheIds)

          this.niches = this.niches.filter(niche => niche && typeof niche === "object")

          this.niches.sort((a, b) => a.code.localeCompare(b.code))

          this.$store.commit('setNiches', this.niches)
          this.$store.commit('setNichesLoaded', true)
        }
      }

      this.isLoading = false
      if (local_debug || this.debug) console.log("Dashboard.mounted: STOP")
    },

    methods: {    
      async handle_countryClick(e) {
        if (this.debug) console.log("")
        if (this.debug) console.log("Dashboard in handle_countryClick: START")
        if (this.debug) console.log("Dashboard in handle_countryClick: nodeindex = ", e.nodeindex)
        if (this.debug) console.log("Dashboard in handle_countryClick: country = ", this.country_labels[e.nodeindex])
        if (this.debug) console.log("Dashboard in handle_countryClick: country_id = ", this.country_ids[e.nodeindex])

        this.currentCountryID = this.country_ids[e.nodeindex];
        this.currentCountry = this.country_labels[e.nodeindex];
        this.title = this.currentCountry;
        await this.showRegions(this.currentCountry);
        
        if (this.debug) console.log("Dashboard in handle_countryClick: STOP")
      },

      async handle_regionClick(e) {
        if (this.debug) console.log("")
        if (this.debug) console.log("Dashboard in handle_regionClick: START")
        if (this.debug) console.log("Dashboard in handle_regionClick: nodeindex = ", e.nodeindex)
        if (this.debug) console.log("Dashboard in handle_regionClick: region = ", this.region_labels[e.nodeindex])
        if (this.debug) console.log("Dashboard in handle_regionClick: region_id = ", this.region_ids[e.nodeindex])

        this.currentRegionID = this.region_ids[e.nodeindex];
        this.currentRegion = this.region_labels[e.nodeindex];
        this.title = this.currentRegion;
        await this.showAppellations(this.currentRegion);

        if (this.debug) console.log("Dashboard in handle_regionClick: STOP")
      },

      async handle_appellationClick(e) {
        if (this.debug) console.log("")
        if (this.debug) console.log("Dashboard in handle_appellationClick: START")

        if (this.debug) console.log("Dashboard in handle_appellationClick: STOP")
      },      

      async onLevelBack() {
        if (this.level == 1) {
          await this.showCountries();
          this.title = "countries";
          this.level = 0;
        }
        if (this.level == 2) {
          await this.showRegions(this.currentCountry);
          this.title = this.currentCountry;
          this.level = 1;
        }
      },

      async showFigures() {
        if (this.debug) console.log("-----> showFigures: START");
        let postdata = {'cellar_id': this.cellar_id};
        await Queries.number_ofBottles(postdata)
        .then(response=>{
          if (this.debug) console.log("-----> showFigures: postdata ", postdata, " has response ", response);
          if (response !=0) {
            this.number_ofBottles = response.total;
          } else {
            this.number_ofBottles = 0;
          }
        })
        .catch(error=>{
          if (this.debug) console.log("-----> showFigures: catch await Queries: ", error);
        })
        if (this.debug) console.log("-----> showFigures: STOP");
      },

      async showVintages() {
        if (this.debug) console.log("-----> showVintages: START");
        let postdata = {'cellar_id': this.cellar_id};
        await Queries.cellar_perVintage(postdata)
        .then(response=>{
          if (this.debug) console.log("-----> showVintages: postdata ", postdata, " has response ", response);
          this.vintage_labels = [];
          this.vintage_values = [];
          for (let i = 0; i < response.length; i++) {
            // let label = {"text":response[i]._id};
            // this.vintage_labels.push(JSON.parse(label));
            this.vintage_labels.push(response[i]._id);
            this.vintage_values.push(response[i].total);
            if (this.debug) console.log("-----> showVintages: i=" + i + " vintage: ",response[i]._id, " total: ",response[i].total);
          }
        })
        .catch(error=>{
          if (this.debug) console.log("-----> showVintages: catch await Queries: ", error);
        })
        if (this.debug) console.log("-----> showVintages: STOP");
      },

      async showColors() {
        if (this.debug) console.log("-----> showColors: START");
        let postdata = {'cellar_id': this.cellar_id};
        await Queries.cellar_perColor(postdata)
        .then(response=>{
          if (this.debug) console.log("-----> showColors: postdata " + postdata + " has response ", response);
          let red_part = {};
          let white_part = {};
          let rose_part = {};
          let rest_part = {};
          for (let i = 0; i < response.length; i++) {
            if (this.debug) console.log("-----> showColors: i=" + i + " color: ",response[i]._id, " total: ",response[i].total);
            if (response[i]._id == "Red") {
              red_part.values = [response[i].total]
              red_part.text = red_part.values + " " + this.translate("Red") + " (" +  Math.round(100*red_part.values/this.number_ofBottles,0) + "%)"
              red_part.backgroundColor = "#b11226"
              if (this.debug) console.log("------> showColors: red = " + red_part.values);
            } else if (response[i]._id == "White") {
              white_part.values = [response[i].total]
              white_part.text = white_part.values + " " + this.translate("White") + " (" +  Math.round(100*white_part.values/this.number_ofBottles,0) + "%)"
              white_part.backgroundColor = "#eccd13"
              if (this.debug) console.log("------> showColors: white = " + white_part.values);
            } else if (response[i]._id == "Rosé") {
              rose_part.values = [response[i].total]
              rose_part.text = rose_part.values + " " + this.translate("Rosé") + " (" +  Math.round(100*rose_part.values/this.number_ofBottles,0) + "%)"
              rose_part.backgroundColor = "#d4a1b1"
              if (this.debug) console.log("------> showColors: rose = " + white_part.values);
            } else {
              rest_part.values = [response[i].total]
              rest_part.text = rest_part.values + " Unknown (" +  Math.round(100*rest_part.values/this.number_ofBottles,0) + "%)"
              rest_part.backgroundColor = "grey"
            }
            
          }
          this.color_series = [red_part,white_part,rose_part, rest_part]
        })
        .catch(error=>{
          if (this.debug) console.log("-----> showColors: catch await Queries: ", error);
        })
        if (this.debug) console.log("-----> showColors: STOP");
      },

      async showCountries() {
        if (this.debug) console.log("-----> showCountries: START");
        let postdata = {'cellar_id': this.cellar_id};
        await Queries.cellar_perCountry(postdata)
        .then(response=>{
          if (this.debug) console.log("-----> showCountries: postdata ", postdata ," has response ", response);
          this.country_ids=[];
          this.country_labels = [];
          this.country_values = [];
          for (let i = 0; i < response.length; i++) {
            this.country_ids.push(response[i]._id);
            this.country_labels.push(response[i].country);
            this.country_values.push(response[i].total);
            if (this.debug) console.log("-----> showCountries: i=" + i + " country: ",response[i]._id, " total: ",response[i].total);
          }
        })
        .catch(error=>{
          if (this.debug) console.log("-----> showCountries: catch await Queries: ", error);
        })
        if (this.debug) console.log("-----> showCountries: STOP");
      },

      async showRegions(country) {
        if (this.debug) console.log("-----> showRegions: START");
        let postdata = {'cellar_id': this.cellar_id,'country': country};
        await Queries.cellar_perRegion(postdata)
        .then(response=>{
          if (this.debug) console.log("-----> showRegions: postdata ", postdata, " has response ", response);
          this.region_ids=[];
          this.region_labels = [];
          this.region_values = [];
          for (let i = 0; i < response.length; i++) {
            this.region_ids.push(response[i]._id);
            this.region_labels.push(response[i].region);
            this.region_values.push(response[i].total);
            if (this.debug) console.log("-----> showRegions: i=" + i + " region: ",response[i].region, " total: ",response[i].total);
          }
          this.level = 1;
        })
        .catch(error=>{
          if (this.debug) console.log("-----> showRegions: catch await Queries: ", error);
        })
        if (this.debug) console.log("-----> showRegions: STOP");
      },

      async showAppellations(region) {
        if (this.debug) console.log("-----> showAppellations: START");
        let postdata = {'cellar_id': this.cellar_id,'region': region};
        await Queries.cellar_perAppellation(postdata)
        .then(response=>{
          if (this.debug) console.log("-----> showAppellations: postdata ", postdata, " has response ", response);
          this.appellation_ids=[];
          this.appellation_labels = [];
          this.appellation_values = [];
          for (let i = 0; i < response.length; i++) {
            this.appellation_ids.push(response[i]._id);
            this.appellation_labels.push(response[i].region);
            this.appellation_values.push(response[i].total);
            if (this.debug) console.log("-----> showAppellations: i=" + i + " appellation: ",response[i].region, " total: ",response[i].total);
          }
        })
        .catch(error=>{
          if (this.debug) console.log("-----> showAppellations: catch await Queries: ", error);
        })
        this.level = 2;
        if (this.debug) console.log("-----> showAppellations: STOP");
      },

      async showTransactions() {
        if (this.debug) console.log("-----> showTransactions: START");
        let postdata = {'cellar_id': this.cellar_id};
        await Queries.cellar_Transactions(postdata)
        .then(response =>{
          if (this.debug) console.log("-----> showTransactions: postdata ", postdata, " has response ", response);
          for ( let i = 0 ; i < response.length ; i++ ) {
            this.transactions.push(response[i])
          }
        })
        .catch(error => {
          if (this.debug) console.log("-----> showTransactions: catch await Queries.cellar_Transactions: ", error);
        })

        this.transactions.sort(function(a, b) {
          if(a.date < b.date) { return 1; } 
          if(a.date > b.date) { return -1; }
          return 0;
        });

        if (this.debug) console.log("-----> showTransactions: STOP");
      },

      async switch2ProfileLanguage() {
        let local_debug = false

        if (local_debug || this.debug) console.log("Home.switch2ProfileLanguage : START")
        this.$store.commit('setLanguage',this.user.language) 

        if (local_debug || this.debug) console.log("Home.switch2ProfileLanguage : STOP")

      },
      async changeProfileanguage() {
        let local_debug = false

        if (local_debug || this.debug) console.log("Home.changeProfileanguage : START")
        
        if (local_debug || this.debug) console.log("Home.changeProfileanguage : changing profile language from ", this.user.language , " to ", this.currentLanguage)
        this.user.language = this.currentLanguage
        await Users.update(this.user_id,this.user)
          .then(response => {
            if (local_debug || this.debug) console.log("Home.changeProfileanguage : User ", response , " succesfully updated!")
          })
          .catch(error => {
            if (local_debug || this.debug) console.log("Home.changeProfileanguage : Catch is await Users error:", error)
          })
        
        if (local_debug || this.debug) console.log("Home.changeProfileanguage : STOP")
      },      
      
      async selectLanguage(language) {
          let local_debug = false
          if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: START");
          this.$store.commit('setLanguage',language)

          let user = this.currentUser
          let user_id = this.currentUserID
          user.language = language
          await Users.update(user_id, user)
          .then(response => {
            if (local_debug || this.debug) console.log ("TastingsOverview.selectLanguage: user ",user.email," updated with response ", response)
          })
          .catch(error => {
            if (local_debug || this.debug) console.log('TastingsOverview.selectLanguage: catch await Users.update ERROR : ', error);
          })

          this.showColors()

          if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: STOP");
      },
      
      translate(string) {
        return translate_word(string, this.currentLanguage);
      },

      translate_language(string, language) {
        return translate_word(string, language);
      },

      getLanguageName(code) {
        const languages = {
            "en": "English",
            "fr": "Français",
            "de": "Deutsch",
            "es": "Español",
            "it": "Italiano",
            "pt": "Português",
            "nl": "Nederlands",
            "ru": "Русский",
            "zh": "中文",
            "ja": "日本語",
            "ko": "한국어",
            "ar": "العربية",
            "hi": "हिन्दी"
        };
        return languages[code] || "Unknown Language"
      }      
    },
  }   
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.c-button-pink {
  background-color: rgb(195,147,130) !important;
  border-color: rgb(195,147,130) !important;
  color:white;
  font-size: clamp(10px,1vw,11px) !important;
  font-weight: bold !important;
  width: clamp(50px,5vw,80px);
}

.c-button-green {
  background-color: rgb(109,122,82) !important;
  border-color: rgb(109,122,82) !important;
  color:white;
  font-size: clamp(12px,1.2vw,16px) !important;
  font-weight: bold !important;
  width: clamp(120px,10vw,160px);
}

#container_ofBottles {

}
#container_perColor {
  position: relative;
  top: -10vh;
  left:0;
  z-index:-1;
}

#hide {
  position: relative;
  bottom: 3vh;
  background-color: white;
}

#container_more {
  background-color:white;
  position: relative;
  top: -45vh;
  margin-top:10px;
  z-index:0;
}

#container_perCountry {
  background-color:white;
  position: relative;
  top: -45vh;
  z-index:0;
}

#container_perVintage {
  position: relative;
  top: -45vh;
  z-index:0;
}

#container_recentTransactions{
  position: relative;
  top: -45vh;
  z-index:0;
}

.correct{
  position: relative;
  top: -45vh;
  margin-block-start: 0;
  margin-block-end: 0;
}

</style>